/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

export type PurchasedGoodsFoodListReviewType = typeof PurchasedGoodsFoodListReviewType[keyof typeof PurchasedGoodsFoodListReviewType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PurchasedGoodsFoodListReviewType = {
  all: 'all',
  food: 'food',
  weight: 'weight',
} as const;
